import React, { useMemo, useState, useEffect } from 'react';
import styles from '../../../PackageBuilders/MultiPose/MultiPose.module.scss';
import Carousel from '../../../PackageBuilders/MultiPose/Carousel';
import { useIndex } from '../../../PackageBuilders/MultiPose/hooks';
import PreviewArea from '../../../PackageBuilders/MultiPose/PreviewArea';
import cn from 'classnames';
import ReviewModal from '../../../PackageBuilders/MultiPose/ReviewModal';

export default function Builder({
                                  backgrounds,
                                  poses,
                                  initialSheets,
                                  isLoading,
                                  option,
                                  packageId,
                                  errors,
                                  onConfirm,
                                  reviewSheets = [],
                                }) {
  const [sheets, setSheets] = useState(initialSheets);

  const {
    decrement,
    decrementDisabled,
    increment,
    incrementDisabled,
    index: currentSheetIndex,
    setIndex,
  } = useIndex({ maxIndex: sheets.length - 1 });

  const availableProductTypes = useMemo(() => {
    if (!initialSheets[currentSheetIndex]) return '';

    return initialSheets[currentSheetIndex].addon.cssName;
  }, [currentSheetIndex, initialSheets[currentSheetIndex], sheets[currentSheetIndex]?.imageUrl]);

  const posesToDisplay = useMemo(() => (
    poses
      .filter((pose) => {
        if (availableProductTypes === 'sibling') return pose.type === 'SiblingImage';

        return true;
      })
  ), [currentSheetIndex]);

  const backgroundsToDisplay = useMemo(() => (
    // backgrounds.filter((bg) => bg.productTypeNames.includes(availableProductTypes))
    backgrounds
  ), [availableProductTypes]);

  const setBackground = (newBackground) => {
    if (sheets.length === 0) return;

    const currentSheet = sheets[currentSheetIndex];

    if (!currentSheet) return;

    currentSheet.background = newBackground;
    currentSheet.backgroundId = newBackground.id;

    setSheets((prev) => ([...prev]));
  };

  /*const setPose = (newPose) => {
    if (sheets.length === 0) return;

    const currentSheet = sheets[currentSheetIndex];

    const currentSheetDup = { ...currentSheet };

    currentSheetDup.pose = newPose;
    currentSheetDup.poseId = newPose.id;

    if (sheets[currentSheetIndex]) sheets[currentSheetIndex] = currentSheetDup;

    if (!currentSheet) return;

    sheets[currentSheetIndex].pose = newPose;
    sheets[currentSheetIndex].poseId = newPose.id;

    sheets[currentSheetIndex].pose = newPose;
    sheets[currentSheetIndex].poseId = newPose.id;

    setSheets(() => ([...sheets]));
  };*/

  useEffect(() => {
    console.log('Sheets updated:', sheets);
  }, [sheets]);
  
  // In setPose function
  const setPose = (newPose) => {
    if (sheets.length === 0) return;
  
    setSheets(currentSheets => {
      const updatedSheets = [...currentSheets];
      updatedSheets[currentSheetIndex] = {
        ...updatedSheets[currentSheetIndex],
        pose: newPose,
        poseId: newPose.id
      };
      console.log('Setting new sheets:', updatedSheets);
      return updatedSheets;
    });
  };

  const sheetIds = sheets.map((s) => s.id);

  const sheetsForReviewModal = reviewSheets.map((rs) => {
    if (!sheetIds.includes(rs.id)) return rs;

    return sheets.find((s) => s.id === rs.id);
  });

  if (!sheets[currentSheetIndex]) return null;

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }} className={cn({
      siblingImage: sheets[currentSheetIndex]?.pose?.type === 'SiblingImage',
    })}>
      <PreviewArea
        currentSheetIndex={currentSheetIndex}
        sheet={sheets[currentSheetIndex]}
        sheets={sheets}
        setSheets={setSheets}
      />
      <div className={styles.carousels}>
        <Carousel
          items={posesToDisplay}
          onClick={(pose) => setPose(pose)}
          text="POSE"
          favoriteIds={[]}
        />
        <div style={{ position: 'relative' }}>
          <div style={{ visibility: initialSheets[currentSheetIndex]?.addon?.backgroundSelection ? 'initial' : 'hidden' }}>
            <Carousel
              items={backgroundsToDisplay}
              onClick={(background) => setBackground(background)}
              text="BACKGROUND"
            />
          </div>
          {!initialSheets[currentSheetIndex]?.addon?.backgroundSelection && (
            <p className={styles.jpgPoseSelected}>The background cannot change on the pose you have selected.</p>
          )}
        </div>
        <div className={styles.btnContainers}>
          <button disabled={decrementDisabled} onClick={decrement} type="button">Back</button>
          {!incrementDisabled && (
            <button onClick={increment} type="button">
              Confirm
            </button>
          )}
          {incrementDisabled && (
            <ReviewModal
              additionalPoses={0}
              option={option}
              isLoading={isLoading}
              errors={errors}
              packageId={packageId}
              sheets={sheets}
              setIndex={setIndex}
              onConfirm={onConfirm}
              onCancel={onConfirm}
              cancelText="+ Add Another Item"
            />
          )}
        </div>
      </div>
    </div>
  );
}
